import { env } from './environment-types';

export const environment = env({
	production: true,
	name: 'production',
});
